import Form from "~/common/components/Form";
import {WarningIcon} from "~/assets/svg/AlertIcon";
import Select from "~/common/components/Select";
import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import useRequest from "~/common/hooks/useRequest";
import {API_STATE} from "~/common/constants/state";
import {Trans, useTranslation} from "react-i18next";
import {CautionIcon, RoundMinusIcon} from "~/assets/svg/InterfaceIcon";
import {useGlobalStore} from "~/store";
import Slider from "react-slick";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import {SolidCloseIcon} from "~/assets/svg/CloseIcon";
import {PlusIcon} from "~/assets/svg/MathIcon";
import ProcessAlerts from "~/pages/review/processingModal/ProcessAlerts";
import Processing from "~/pages/review/processingModal/Processing";
import {AppContext} from "~/pages/round/RoundReg/RoundRegContext";

const settings = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
};

const RoundReview = ({ targetModifyIdx, roundRegForm, reviewSettingData, setReviewSettingData}) => {
    const { t } = useTranslation();
    const [
        {
            theme: { theme },
        },
    ] = useGlobalStore();

    const {
        reviewContent,
        judgeList, setJudgeList,
        attendFilter, setAttendFilter,
        outSourcing, setOutSourcing,
    } = useContext(AppContext);

    // ##### state
    // 심사항목
    const [itemList, setItemList] = useState();
    const [roundItemModal, setRoundItemModal] = useState(false);
    const [settingList, setSettingList] = useState([{ label: "선택 안함", value: 0 }]);

    // 수정일때만 기본 데이터 set
    const [defaultReview, setDefaultReview] = useState(null);

    // 심사항목 신규 등록
    const [deleteAlertModal, setDeleteAlertModal] = useState(false);
    const [noCategoryAlert, setNoCategoryAlert] = useState(false);
    const [weightingAlert, setWeightingAlert] = useState(false);
    const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
    const [noTitleAlert, setNoTitleAlert] = useState(false);
    const [noCategoryName, setNoCategoryName] = useState(false);
    const [noItemName, setNoItemName] = useState(false);
    const [settingDetail, setSettingDetail] = useState({});

    const [resetItemData, setResetData] = useState("");
    const [targetIdx, setTargetIdx] = useState("");


    // 심사역
    // const [judgeList, setJudgeList] = useState([]);

    // const [attendFilter, setAttendFilter] = useState([]);
    // 외부 심사역
    // const [outSourcing, setOutSourcing] = useState([]);


    // ##### api
    // 심사항목
    const settingListRequest = useRequest("get", "/vc/round/setting/list"); // 심사항목 조회
    const settingCreateRequest = useRequest("post", "/vc/round/setting/add");

    // 심사역
    const toggleJudgeRole = (userIdx, idx) => {
        const choose = judgeList.find((d) => d.userIdx === userIdx);
        if (judgeList.filter((d) => d.role !== "")?.length === 10 && choose.role === "") {
            alert(t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.alert"));
            return;
        }
        let newData;
        if (idx === 0 || idx === "0") {
            newData = judgeList.map((d) =>
                d.userIdx === userIdx
                    ? {
                        ...d,
                        role:
                            d.role === "심사참여"
                                ? "심사관망"
                                : d.role === "심사관망"
                                    ? "심사참여"
                                    : "심사참여",
                    }
                    : d
            );
        } else {
            newData = judgeList.map((d) =>
                d.userIdx === userIdx
                    ? {
                        ...d,
                        role:
                            d.role === ""
                                ? "심사참여"
                                : d.role === "심사참여"
                                    ? "심사관망"
                                    : d.role === "심사관망"
                                        ? ""
                                        : "",
                    }
                    : d
            );
        }
        setJudgeList(newData);
    };

    const handleRemoveJudge = (userIdx) => {
        const removeData = judgeList.map((d) => (d.userIdx === userIdx ? { ...d, role: "" } : d));
        setJudgeList(removeData);
    };

    const handleNewCreation = (createFormData) => {
        settingCreateRequest.call(createFormData);
    };

    // 외부 심사역
    const handleAddOutSourcing = () => {
        setOutSourcing([
            ...outSourcing,
            { userIdx: 0, role: "심사참여", external: true, email: "", name: "", id: "", pw: "" },
        ]);
    };
    const handleNameInputChange = (e, idx) => {
        const newData = outSourcing.map((d, index) =>
            index === idx ? { ...d, name: e.target.value } : d
        );
        setOutSourcing(newData);
    };
    const handleIdInputChange = (e, idx) => {
        const newData = outSourcing.map((d, index) =>
            index === idx ? { ...d, id: e.target.value } : d
        );
        setOutSourcing(newData);
    };
    const handlePasswordInputChange = (e, idx) => {
        const newData = outSourcing.map((d, index) =>
            index === idx ? { ...d, pw: e.target.value } : d
        );
        setOutSourcing(newData);
    };

    const handleEmailInputChange = (e, idx) => {
        const newData = outSourcing.map((d, index) =>
            index === idx ? { ...d, email: e.target.value } : d
        );
        setOutSourcing(newData);
    };
    const handleRemoveOutSourcing = (idx) => {
        const newData = outSourcing.filter((d, index) => index !== idx);
        setOutSourcing(newData);
    };

    // 공지사항
    const handleNotice = (e) => {
        if (e.target.name === "noticeContent") {
            const content = e.target.value;
            if (content.length > 500) {
                return;
            }
        }
        setReviewSettingData({ ...reviewSettingData, [e.target.name]: e.target.value });
    };

    // ##### useEffect
    //심사항목
    useEffect(() => {
        switch (settingListRequest.state) {
            case API_STATE.done:
                const listData = [];
                setItemList(settingListRequest.response?.data?.list);
                settingListRequest.response?.data?.list?.map((d) =>
                    listData.push({ label: d.title, value: d.idx })
                );

                if(Object.keys(reviewContent)?.length > 0) {
                    const filterReview = settingList.filter(item => item.label === reviewContent?.review?.title);
                    if(filterReview?.length > 0) {
                        roundRegForm.setValue("evaluateTemplate", filterReview[0]?.value);
                    } else {
                        // roundRegForm.setValue("evaluateTemplate", reviewContent?.review?.title);
                        // console.log("no filtered ", reviewContent)
                    }
                }
                setSettingList(listData);
                break;
            case API_STATE.error:
                break;
            default:
                break;
        }
    }, [settingListRequest.state, settingListRequest.error, settingListRequest.response, reviewContent]);

    useEffect(() => {
        switch (settingCreateRequest.state) {
            case API_STATE.done:
                setRoundItemModal(false);
                settingListRequest.call();
                break;
            case API_STATE.error:
                break;
            default:
                break;
        }
    }, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);

    // 심사역



    // 내부&외부 데이터 set
    const handleSetJudgeData = () => {
        const internalData = judgeList?.filter(d => d.role !== "");
        setReviewSettingData({
            ...reviewSettingData,
            judgeList: [
                ...internalData,
                ...outSourcing,
            ]
        })
    }

    // 수정일때 data set
    const handleSetData = () => {
        const externalList = reviewContent?.judgeList?.filter(item => item.external);
        // setOutSourcing(externalList);

        setOutSourcing(externalList?.map((item, idx) => ( {
            userIdx: item.userIdx,
            role: item.role,
            external: true,
            email: item.email,
            name: item.name,
            id: item.id,
            pw: item.pw
        })));

        setReviewSettingData({
            ...reviewSettingData,
            noticeTitle: reviewContent.noticeTitle,
            noticeContent: reviewContent.noticeContent,
            noticeCheck: reviewContent.noticeCheck
        });
    }

    // 내부&외부 심사
    useEffect(() => {
        (judgeList?.length > 0 || outSourcing?.length > 0) && handleSetJudgeData()
    }, [judgeList, outSourcing])

    useEffect(() => {
        judgeList && setAttendFilter(judgeList?.filter((d) => d.role !== "") ?? []);
    }, [judgeList])

    // 수정일때 data set
    useEffect(() => {
        (reviewContent && Object.keys(reviewContent)?.length > 0) && handleSetData();
    }, [reviewContent])

    useLayoutEffect(() => {
        settingListRequest.singleCall();
    }, []);


    return (
        <div className="c__card review_card">
                <div className="card-header">
                    <h2 className="form-name required">심사 설정</h2>
                    <div className="divider" />
                    <p className="form-text">해당 지원 프로그램에 해당하는 심사항목과 심사역을 선택해주세요.</p>
                </div>

                <div className="review-wrap">
                    <Form useForm={roundRegForm} className={"evaluate-template-group"}>
                        {
                            // @INFO 삭제된 심사항목의 경우 제목만 표시해주기 넘길때는 null 값으로 넘겨야 하기 때문에 required 를 해제해준다.
                            (reviewContent?.review?.title) ?
                                <Select
                                    label={t("pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.label02")}
                                    name="evaluateTemplate"
                                    options={settingList}
                                    placeholder={reviewContent?.review?.title}
                                /> :
                                <Select
                                    label={t("pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.label02")}
                                    name="evaluateTemplate"
                                    options={settingList}
                                    placeholder={settingList?.length > 0 ? "선택해주세요." : "등록된 심사항목이 없습니다. 심사항목 신규 등록 버튼을 클릭하여 심사항목을 추가해주세요!"}
                                    required
                                />
                        }
                        <button
                            type="button"
                            className="btn__outline btn-create"
                            color="primary"
                            onClick={() => setRoundItemModal(true)}
                        >
                            심사항목 신규 등록
                        </button>
                    </Form>
                    { (targetModifyIdx) && <div className="notice"> ※ 설정한 심사항목을 삭제한 경우에는 심사항목 변경시, 목록에서 삭제되어 선택이 불가능합니다.</div> }
                </div>



                {/* 내부 심사역 선택 start */}
                <div className="f__group judge-group-wrap ">
                    <div className="f__label required">
                        <p>내부 심사역 선택</p>
                    </div>
                    <div className={"modal-content judgeSetup"}>
                        <div className="f__control setup-card">
                            <Slider {...settings} className="vc-carousel">
                                {judgeList?.map((d, idx) => {
                                    return (
                                        <div
                                            className="participant"
                                            key={d.userIdx}
                                            onClick={() => toggleJudgeRole(d.userIdx, idx)}
                                        >
                                            <div
                                                className={`img-wrap ${
                                                    d.role === "심사참여"
                                                        ? "attend"
                                                        : d.role === "심사관망"
                                                            ? "watching"
                                                            : null
                                                }`}
                                            >
                                                <img
                                                    src={
                                                        d.img ||
                                                        (theme === "dark"
                                                            ? DarkDefaultProfileImg
                                                            : LightDefaultProfileImg)
                                                    }
                                                    alt={t(
                                                        "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.imageAlt"
                                                    )}
                                                />
                                            </div>
                                            <h5 className={"participant-info"}>
                                                {d.name}{" "}
                                                {idx === 0 &&
                                                    t(
                                                        "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.info"
                                                    )}
                                            </h5>
                                        </div>
                                    );
                                })}
                            </Slider>
                            <div className="participant-list-wrap">
                                <p className="participant-num">
                                    <Trans
                                        i18nKey="pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.participant"
                                        components={[<b />, { attendFilter }]}
                                    />
                                </p>
                                <div className="scroll-wrap">
                                    <ul className="participant-list">
                                        {attendFilter?.map((d, idx) =>
                                            idx === 0 ? (
                                                <li key={idx}>
                                                    {d.name +
                                                        `(${d.role === "심사참여" ? "참여" : "관망"})`}
                                                </li>
                                            ) : (
                                                <li key={idx}>
                                                    {d.name +
                                                        `(${d.role === "심사참여" ? "참여" : "관망"})`}
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveJudge(d.userIdx, idx)}
                                                    >
                                                        <SolidCloseIcon />
                                                    </button>
                                                </li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {/* 내부 심사역 선택 end */}

                <div className="f__group external-judge-group-wrap">
                    <div className="f__label">
                        외부 심사역 초대
                    </div>
                    <div className={"modal-content externalJudgeSetup"}>
                        <div className="f__control setup-card">
                            <button
                                type="button"
                                className="dashed-btn plus-btn"
                                onClick={handleAddOutSourcing}
                            >
                                <PlusIcon />
                                {t(
                                    "pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.button01"
                                )}
                            </button>
                            {outSourcing?.map((d, idx) => {
                                return (
                                    <div className="scroll-wrap" key={idx}>
                                        <div className="f__group-row">
                                            <div className="f__group">
                                                <div className="f__control">
                                                    <input
                                                        className="c__input external-name"
                                                        placeholder={t(
                                                            "pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.namePlaceholder"
                                                        )}
                                                        value={d.name}
                                                        onChange={(e) =>
                                                            handleNameInputChange(e, idx)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="f__group">
                                                <div className="f__control">
                                                    <input
                                                        className="c__input external-id"
                                                        placeholder={t(
                                                            "pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.idPlaceholder"
                                                        )}
                                                        value={d.id}
                                                        onChange={(e) =>
                                                            handleIdInputChange(e, idx)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="f__group">
                                                <div className="f__control">
                                                    <input
                                                        type="password"
                                                        className="c__input external-pw"
                                                        placeholder={t(
                                                            "pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.pwPlaceholder"
                                                        )}
                                                        value={d.pw}
                                                        onChange={(e) =>
                                                            handlePasswordInputChange(e, idx)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="f__group">
                                                <div
                                                    className={`f__control ${
                                                        d.email ? "" : "has-error"
                                                    }`}
                                                >
                                                    <input
                                                        type="email"
                                                        className="c__input external-email"
                                                        value={d.email}
                                                        placeholder={t(
                                                            "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.emailPlaceholder"
                                                        )}
                                                        onChange={(e) =>
                                                            handleEmailInputChange(e, idx)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn-round-delete"
                                                onClick={() => handleRemoveOutSourcing(idx)}
                                            >
                                                <RoundMinusIcon />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/*<div className="f__group notice-register-wrap">*/}
                {/*    <div className="f__label">*/}
                {/*        공지사항을 등록*/}
                {/*    </div>*/}
                {/*    <div className="f__control">*/}
                {/*        <div className="message_wrap">*/}
                {/*            <p className="text">&#42;해당 공지사항은 심사위원에게 전달되는 공지사항입니다.</p>*/}
                {/*            <label className="switch">*/}
                {/*                <input*/}
                {/*                    type="checkbox"*/}
                {/*                    checked={reviewSettingData.noticeCheck}*/}
                {/*                    onClick={() => setReviewSettingData({...reviewSettingData, noticeCheck: !reviewSettingData.noticeCheck})}*/}
                {/*                />*/}
                {/*                <span className="slider round" />*/}
                {/*                <span className="slider-label">*/}
				{/*			{t(*/}
                {/*                "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.sliderLabel"*/}
                {/*            )}*/}
				{/*		</span>*/}
                {/*            </label>*/}
                {/*        </div>*/}
                {/*        <div className="setup-card">*/}
                {/*            {reviewSettingData.noticeCheck ? (*/}
                {/*                <>*/}
                {/*                    <div className="f__group">*/}
                {/*                        <div className="f__control">*/}
                {/*                            <input*/}
                {/*                                type="text"*/}
                {/*                                className="c__input notice-title"*/}
                {/*                                placeholder={t(*/}
                {/*                                    "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.inputPlaceholder"*/}
                {/*                                )}*/}
                {/*                                name={"noticeTitle"}*/}
                {/*                                value={reviewSettingData.noticeTitle}*/}
                {/*                                onChange={(e) => handleNotice(e)}*/}
                {/*                            />*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    <div className="f__group">*/}
                {/*                        <div className="f__control">*/}
				{/*					<textarea*/}
                {/*                        className="c__textarea"*/}
                {/*                        placeholder={t(*/}
                {/*                            "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.textareaPlaceholder"*/}
                {/*                        )}*/}
                {/*                        name="noticeContent"*/}
                {/*                        value={reviewSettingData.noticeContent}*/}
                {/*                        onChange={(e) => handleNotice(e)}*/}
                {/*                    />*/}
                {/*                            <span className="character-length">*/}
				{/*						{reviewSettingData?.noticeContent?.length}/500*/}
				{/*					</span>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                </>*/}
                {/*            ) : (*/}
                {/*                <div className="c__noData">*/}
                {/*                    <CautionIcon />*/}
                {/*                    <p className="main">*/}
                {/*                        {t(*/}
                {/*                            "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.noDataTitle"*/}
                {/*                        )}*/}
                {/*                    </p>*/}
                {/*                    <p className="sub">*/}
                {/*                        {t(*/}
                {/*                            "pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.noDataText"*/}
                {/*                        )}*/}
                {/*                    </p>*/}
                {/*                </div>*/}
                {/*            )}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}


            <Processing
                {...{
                    settingDetail,
                    setSettingDetail,
                    createNew: "create",
                    roundItemModal,
                    setRoundItemModal,
                    setNoCategoryAlert,
                    setWeightingAlert,
                    setNoEvaluationAlert,
                    setNoTitleAlert,
                    resetItemData,
                    setResetData,
                    setNoCategoryName,
                    setNoItemName,
                    handleModify: () => {},
                    handleNewCreation,
                    targetIdx,
                }}
            />
            <ProcessAlerts
                {...{
                    noCategoryAlert,
                    setNoCategoryAlert,
                    weightingAlert,
                    setWeightingAlert,
                    deleteAlertModal,
                    setDeleteAlertModal,
                    noEvaluationAlert,
                    setNoEvaluationAlert,
                    noTitleAlert,
                    setNoTitleAlert,
                    noCategoryName,
                    setNoCategoryName,
                    noItemName,
                    setNoItemName,
                    targetIdx,
                }}
            />

        </div>
    )
}

export default RoundReview
